<template>
<div class="row">
  <div class="col-md-8">
    <div class="panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title">Your cards</h3>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="row" id="div-cards">
              <div class="" v-for="cc in cards">

                <div class="col-md-6" style="border: 1px solid rgb(215, 215, 215);">
                  <div class="card-type text-right">{{ cc.brand }}</div>
                  <div class="card-number text-center">**** **** **** {{ cc.last_4 }}</div>
                  <span class="card-holder-name pull-left">{{ cc.name }}</span>
                  <span class="card-holder-name pull-right">{{ cc.exp_month }}/{{ cc.exp_year }}</span>
                  <span class="card-actions row">
                    <div class="col-sm-12 text-right">
                      <a :id="'card_id_btn_' + cc.id" class="btn btn-danger btn-custom m-b-5 ladda-button pull-right" @click="deleteCard(cc.id)">Delete card</a>
                    </div>
                  </span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="panel panel-default credit-card-box">
      <div class="panel-heading display-table">
        <h3 class="panel-title display-td" style="min-width: 100%;">Add a new card</h3>
        <div class="display-td">
          <img class="img-responsive pull-right" src="assets/images/accepted_c22e0.png">
        </div>
      </div>
      <div class="panel-body">
        <form role="form" id="form-add-card" v-on:submit.prevent>
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label for="input-name-on-card">Name on Card</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    name="input-name-on-card"
                    placeholder=""
                    autocomplete="cc-number"
                    id="input-name-on-card"
                    required autofocus
                    v-model="card.name"
                    value=""
                    />
                  <span class="input-group-addon"><i class="fa fa-user"></i></span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label for="input-card-number">Card number</label>
                <div class="input-group">
                  <input
                    type="tel"
                    class="form-control"
                    name="input-card-number"
                    placeholder="XXXXXXXXXXXXXXXX"
                    autocomplete="cc-number"
                    data-stripe="number"
                    required autofocus
                    v-model="card.number"
                    />
                  <span class="input-group-addon"><i class="fa fa-credit-card"></i></span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-7 col-md-7">
              <div class="form-group">
                <label for="input-card-expiry"><span class="hidden-xs">Expiration</span><span class="visible-xs-inline">EXP</span> date</label>
                <div class="col-sm-4" style="padding-left: 0px !important; padding-right: 0px !important;">
                  <input
                    type="tel"
                    class="form-control"
                    name="input-card-expiry"
                    placeholder="MM"
                    autocomplete="cc-exp"
                    required
                    data-stripe="exp-month"
                    v-model="card.exp_month"
                    />
                </div>
                <div class="col-sm-1" style="font-size: 20px;">
                  /
                </div>
                <div class="col-sm-6"><input
                  type="tel"
                  class="form-control"
                  name="input-card-expiry"
                  placeholder="YYYY"
                  autocomplete="cc-exp"
                  required
                  data-stripe="exp-year"
                  v-model="card.exp_year"
                  />
                </div>
              </div>
            </div>
            <div class="col-xs-5 col-md-5 pull-right">
              <div class="form-group">
                <label for="input-card-cvc">CV code</label>
                <input
                  type="tel"
                  class="form-control"
                  name="input-card-cvc"
                  placeholder="CVC"
                  autocomplete="cc-csc"
                  data-stripe="cvc"
                  v-model="card.cvc"
                  required
                  />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <div class="checkbox">
                  <label class="cr-styled">
                    <input name="input-primary" id="checkbox-primary" v-model="card.primary" type="checkbox">
                    <i class="fa"></i>
                    Use as primary payment source?
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <button class="btn btn-success btn-custom m-b-5 ladda-button" id="btn-add-card"
                @click="createToken"
                :disabled="loading"
                :class="{ disabled: loading }"
              >Add card</button>
            </div>
          </div>
          <div class="row">
            <div v-for="error in errors" class="text-center">
              <p style="color: red;">{{ error }}</p>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['stripePk', 'cards'],
  data () {
    return {
      card: {
        name: null,
        number: null,
        cvc: null,
        exp_month: null,
        exp_year: null,
        primary: true
      },
      loading: false,
      errors: []
    }
  },
  created () {
    Stripe.setPublishableKey(this.stripePk)
    console.log(this.cards)
  },
  computed: {
    csrf_token () {
      return document.querySelector("meta[name='csrf-token']")
        .getAttribute('content')
    }
  },
  methods: {
    createToken () {
      this.loading = true
      this.errors = []

      Stripe.card.createToken({
        name: this.card.name,
        number: this.card.number,
        cvc: this.card.cvc,
        exp_month: this.card.exp_month,
        exp_year: this.card.exp_year,
      }, this.stripeResponseHandler);
    },
    stripeResponseHandler (status, response) {
      if (response.error) {
        this.loading = false
        this.errors.push(response.error.message)

        return
      }
      axios.post('/stripe_cards', {
        card: {
          token: response.id,
          card_id: response.card.id,
          name: response.card.name,
          brand: response.card.brand,
          country: response.card.country,
          exp_month: response.card.exp_month,
          exp_year: response.card.exp_year,
          fingerprint: response.card.fingerprint,
          funding: response.card.funding,
          last_4: response.card.last4,
          primary: this.card.primary
        }
      }, {
        headers: { 'X-CSRF-Token': this.csrf_token }
      })
      .then(response => {
        this.loading = false
        this.addCard
        location.reload()
      })
      .catch(e => {
        this.loading = false
        console.log(e.response.data)

        var resp_errors = e.response.data.errors
        for (var key in resp_errors) {
          if (resp_errors.hasOwnProperty(key)) {
            this.errors.push(key + " " + resp_errors[key])
          }
        }
      })
    },
    addCard (card) {
      this.clearCardForm
    },
    clearCardForm () {
      this.card.name = null
      this.card.number = null
      this.card.cvc = null
      this.card.exp_month = null
      this.card.exp_year = null
      this.card.primary = true
    },
    deleteCard (id) {
      document.getElementById('card_id_btn_' + id).classList.add('disabled')

      axios.delete('/stripe_cards/' + id, {
        headers: { 'X-CSRF-Token': this.csrf_token }
      })
      .then(response => {
        location.reload();
      })
      .catch(e => {
        console.log(e.response.data)
        location.reload();
      })
    }
  }
}
</script>

<style>
.StripeElement {
  background-color: white;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/billing/add-card.vue?67e2f872